import { Badge } from "@circleco/compass/components/Badge";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { colord } from "colord";
// TODO: Extract to a shared location — duplicated from `@/react/components/PostsCompass`.
import type { CSSProperties } from "react";

import type { MemberTag as MemberTagType } from "@/react/types/MemberTag";

import { useEmoji } from "./useEmoji";

const getTagTextColor = (tagColor: string) =>
  colord(tagColor).isDark() ? "#ffffff" : "#000000";

type BadgeBrandedStyles = CSSProperties & {
  "--color-background-badge-branded": string;
  "--color-text-badge-branded": string;
  "--color-border-badge-branded": string;
};

interface MemberTagProps {
  tag: MemberTagType;
}

export const MemberTag = ({ tag }: MemberTagProps) => {
  const isIcon = tag.display_format === "icon";
  const hasNoIconContent =
    isIcon && !tag.emoji && !tag.custom_emoji_url && !tag.custom_emoji_dark_url;
  const customColor = tag.is_background_enabled ? tag.color : undefined;
  const hasCustomColor = Boolean(customColor);
  const emojiProps = useEmoji(tag);

  if (hasNoIconContent) return null;

  const customStyles: BadgeBrandedStyles | undefined = customColor
    ? {
        "--color-background-badge-branded": customColor,
        "--color-text-badge-branded": getTagTextColor(customColor),
        "--color-border-badge-branded": customColor,
      }
    : undefined;

  const badge = (
    <Badge
      {...emojiProps}
      style={customStyles}
      label={(!isIcon && tag.name) || ""}
      variant={hasCustomColor ? "branded" : "secondary"}
    />
  );

  if (isIcon && tag.name) return <Tooltip content={tag.name}>{badge}</Tooltip>;

  return badge;
};
